import { defineMessages } from '@atlassian/jira-intl';

export default defineMessages({
	overTwelveWeekMedian: {
		id: 'software-cycle-time-breakdown-report.issue-table.cycle-time-cell-content.over-twelve-week-median',
		defaultMessage: 'Cycle time over 12-week median',
		description:
			'Hover tooltip when mouse is hovered over up icon indicating the cycle time is over the 12-week median',
	},
	underTwelveWeekMedian: {
		id: 'software-cycle-time-breakdown-report.issue-table.cycle-time-cell-content.under-twelve-week-median',
		defaultMessage: 'Cycle time under 12-week median',
		description:
			'Hover tooltip when mouse is hovered over down icon indicating the cycle time is under the 12-week median',
	},
	cycleTimeTrendLabel: {
		id: 'software-cycle-time-breakdown-report.issue-table.cycle-time-cell-content.cycle-time-trend-label',
		defaultMessage: 'Cycle time trend',
		description: 'Label for cycle time trend',
	},
});
